var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAddWithColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.00195C6.486 2.00195 2 6.48795 2 12.002C2 17.516 6.486 22.002 12 22.002C17.514 22.002 22 17.516 22 12.002C22 6.48795 17.514 2.00195 12 2.00195ZM17 13.002H13V17.002H11V13.002H7V11.002H11V7.00195H13V11.002H17V13.002Z",
    fill: "#455CC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddWithColor);
export default __webpack_public_path__ + "static/media/IconAddWithColor.afaa48ce.svg";
export { ForwardRef as ReactComponent };